import { defineComponent as _defineComponent } from 'vue';
import CompanyLayout from '@/Layouts/Company.vue';
import InputText from 'primevue/inputtext';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode } from "primevue/api";
import Dropdown from "primevue/dropdown";
import UserDetails from '@/Components/Company/UserDetails.vue';
import Sidebar from "primevue/sidebar";
import ToggleButton from 'primevue/togglebutton';
import { ref } from 'vue';
import { useSpinner } from '../../Plugins/spinner';
import CompanyUserService from '../../Services/CompanyUserService';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UsersList',
    props: {
        company: Object,
        users: Array,
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const users = props.users;
        const spinner = useSpinner();
        const companyUserService = new CompanyUserService();
        const selectedAction = ref(null);
        const nonattivo = ref(false);
        const attivo = ref(true);
        const actions = [
            { name: "Elimina Selezionati", code: "NY" },
            { name: "Attiva Selezionati", code: "RM" },
            { name: "Disattiva Selezionati", code: "LDN" },
        ];
        const selectedUsers = ref([]);
        const filters = ref({
            global: { value: undefined, matchMode: FilterMatchMode.CONTAINS },
            firstname: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            lastname: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            enabled: { value: null, matchMode: FilterMatchMode.EQUALS },
        });
        const loading = false;
        const enabledOptions = [{ name: "Attivo" }, { name: "Non Attivo" }];
        const visibleRight = ref(false);
        const changeEnabled = (user) => {
            spinner.show();
            companyUserService.update(props.company?.id, user.id, { enabled: user.enabled })
                .then((res) => {
                Object.assign(user, res.data.data);
            })
                .finally(() => spinner.hide());
        };
        const __returned__ = { props, users, spinner, companyUserService, selectedAction, nonattivo, attivo, actions, selectedUsers, filters, loading, enabledOptions, visibleRight, changeEnabled, CompanyLayout, get InputText() { return InputText; }, get DataTable() { return DataTable; }, get Column() { return Column; }, get Dropdown() { return Dropdown; }, UserDetails, get Sidebar() { return Sidebar; }, get ToggleButton() { return ToggleButton; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
